/**
 *
 * @param {Array<StepProps>} steps
 */
const resetHooks = (steps) => {
  for (const step of steps.values()) {
    /** Reset percentage hooks. Set as inactive for the next repeat */

    if (step.get("has-offset-hook")) {
      const offsets = /** @type {PropertyOffsetHooksProps} */ (
        step.get("offset-hooks")
      );

      for (const status of offsets.values()) {
        status.set("enter-active", false);
      }
    }
  }
};

export default resetHooks;
